import { ReactElement, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IUserListCardProps } from '.';
import { convertISODateTODDMMYY } from '@helper/utils';
import { useEndUserStore } from '@store/enduser';
import { useStoreFormikFormValue } from '@store/setFormikFormValueStore';
import { enrollFormRedirection, toEnrollFormSection } from '@components/members/components/userCard';
import { useCloseLeadsPopup } from '@store/closeLeadsPopupStore';
import { closeLeadsDropDown } from '@config/constant';
import { useIsImpersonationLoginUser } from '../../../../../authGuard/hooks/useIsImpersonationLoginUser';
export const UserListCard = (props: IUserListCardProps): ReactElement => {
	const { data, isHideButton } = props;
	const navigate = useNavigate();
	const { setModal, setDropDownData } = useCloseLeadsPopup((state) => state);
	const isImpersonationLoginUser = useIsImpersonationLoginUser();

	const {
		setActiveNavTab,
		setIsFormEdit,
		setFormId,
		setFormRevalidate,
		setSelectSubContractor: setStoreValue,
	} = useEndUserStore();
	const { resetFormikValuesToStore } = useStoreFormikFormValue();
	const handleNavigate = (): void => {
		if (data?.lead_status === 'Enrolled') {
			navigate('/contractor', {
				state: {
					userData: { ...data },
					path: '/all',
				},
			});
			return;
		}
		navigate('/lms/contractor', {
			state: { userInfo: { ...data } },
		});
	};
	const handleEnrollClick = useCallback((): void => {
		if (data?.id && data?.status) {
			setFormId(Number(data.id));
			setIsFormEdit(false);
			setFormRevalidate(false);
			setStoreValue?.([]);
			resetFormikValuesToStore();

			const section = toEnrollFormSection(data?.status === 'Pending' ? 'Basic Details' : data?.status);
			if (section && enrollFormRedirection[section]) {
				navigate(enrollFormRedirection[section].path);
				setActiveNavTab(enrollFormRedirection[section].activeTabs);
			}
		}
	}, [navigate, setActiveNavTab, setFormId, setFormRevalidate, setIsFormEdit, data]);

	return (
		<>
			<li className="d-col d-col-2">
				<div
					className={'user-details-card' + (data.lead_status === 'Pending' ? ' pending' : '')}
					role="button"
					tabIndex={0}
					onClick={handleNavigate}
					aria-label={data?.name}
				>
					<span className="user-name h2" title={data?.name}>
						{data?.name}
					</span>
					<div className="user-details-wrapper">
						<div className="user-info-wrapper">
							<div className="user-about-info">
								{isHideButton ? (
									<span>Added by - {data.added_by ? data.added_by : data.mdicode} </span>
								) : (
									<span>Assigned to - {data.added_to}</span>
								)}
								<span>{convertISODateTODDMMYY(data?.createddate)}</span>
							</div>

							<span className="contact-info">
								<Link
									to={`tel:+91${data?.phone}`}
									aria-label="call user"
									className="contact-info"
									onClick={(e) => e.stopPropagation()}
								>
									<span className="icon-call"></span>
								</Link>
							</span>
						</div>

						<div className="user-tag-wrapper">
							{data.competition_tag && <span className="rounded-btn primary">Competition</span>}

							{data.lead_status === 'Enrolled' && <span className="rounded-btn green-outline">{data.lead_status}</span>}
							{data.lead_status === 'Pending' && (
								<span className="rounded-btn green-outline pending-status">{data.lead_status}</span>
							)}
							{data.lead_status === 'Rejected' && (
								<span className="rounded-btn green-outline rejected-status">
									{data.lead_status} - {data.non_end_category_c}
								</span>
							)}
						</div>

						{isHideButton && data.lead_status !== 'Enrolled' && data.lead_status !== 'Rejected' && (
							<div className="user-status-btn">
								<button
									className="btn btn-primary"
									onClick={(e) => {
										e.stopPropagation();
										handleEnrollClick();
									}}
									disabled={isImpersonationLoginUser}
								>
									Enroll
								</button>
								<button
									className="btn btn-cancel"
									onClick={(e) => {
										e.stopPropagation();
										setModal(true);
										setDropDownData({ id: Number(data.id), name: data.name, number: data.phone }, closeLeadsDropDown);
									}}
									disabled={isImpersonationLoginUser}
								>
									Close Lead
								</button>
							</div>
						)}
					</div>
				</div>
			</li>
		</>
	);
};
